document.addEventListener('DOMContentLoaded', function() {
    function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function floatAnimation(element) {
        const animDuration = random(5, 10);
        element.style.animation = `float ${animDuration}s ease-in-out infinite`;
    }

    function addHideClass(element) {
        if (!element.classList.contains('is-hide')) {
            element.classList.add('is-hide');
        }
    }

    function removeElementWithTransition(element, parentElement) {
        // 5秒から20秒のランダムな時間後にis-hideを追加
        setTimeout(() => addHideClass(element), random(5000, 20000));

        // transitionendで要素を削除
        element.addEventListener('transitionend', function() {
            element.remove();
            if (parentElement.children.length < 10) {
                createFlare(parentElement); // 新しいオブジェクトを生成
            }
        });
    }

    function createFlare(parentElement) {
        if (parentElement.children.length >= 10) return; // 10個以上生成しない

        const div = document.createElement('div');
        const classNumber = random(1, 3);
        div.className = `illumi-deco-flare-${classNumber}`;
        parentElement.appendChild(div);

        // 位置を設定
        const divWidth = parseInt(getComputedStyle(div).width, 10);
        const divHeight = parseInt(getComputedStyle(div).height, 10);
        const parentRect = parentElement.getBoundingClientRect();

        // 親要素の内側でランダムな位置に配置
        const maxTop = parentRect.height - divHeight - 20;
        const maxLeft = parentRect.width - divWidth;
        div.style.left = `${random(0, maxLeft)}px`;
        div.style.top = `${random(0, maxTop)}px`;

        // アニメーションを適用
        floatAnimation(div);

        // クリックイベントリスナーを追加
        div.addEventListener('click', function() {
            addHideClass(div);
        });

        // トランジションと削除のロジックを追加
        removeElementWithTransition(div, parentElement);
    }

    function init(parentElements) {
        const isMobile = window.innerWidth <= 768;
        const flaresCount = isMobile ? 5 : 10; // スマホでは少なめに

        parentElements.forEach(parentElement => {
            while (parentElement.firstChild) {
                parentElement.removeChild(parentElement.firstChild);
            }
            for (let i = 0; i < flaresCount; i++) {
                createFlare(parentElement);
            }
        });
    }

    // 横方向のリサイズイベントに限定
    let lastWindowWidth = window.innerWidth;
    window.addEventListener('resize', function() {
        const currentWidth = window.innerWidth;
        if (currentWidth !== lastWindowWidth) {
            init(document.querySelectorAll('.illumi-deco-particle__flare'));
            lastWindowWidth = currentWidth;
        }
    });

    // 初期化
    init(document.querySelectorAll('.illumi-deco-particle__flare'));
});
